import { ProgramContainer } from "../entities/formTemplateDataType";
import { AbstractPageRedirectHandler } from "./AbstractPageRedirectHandler";

export enum ResponseAttributes {
    SendToDCPID = 'sendToDCPID',
  }

 /**
  * To handle page-redirection related requests in dashboard-id-applications application.
  */
export class DashboardIdApplicationsPageRedirectHandler implements AbstractPageRedirectHandler {
  constructor() {}
  programContainer: ProgramContainer;

  isRedirectionRequired(): boolean {
    console.log('about to execute isRedirectionRequired in DashboardIdApplicationsPageRedirectHandler...');
    const clonedUrl = new URL(window.location.href);
    const approvalStatus = clonedUrl.searchParams?.get(ResponseAttributes.SendToDCPID);

		return (!!approvalStatus);
  }

  isProcessSuccessful(): boolean {
    console.log('about to execute isProcessSuccessful in DashboardIdApplicationsPageRedirectHandler...');

		return true;
  }

  getTransactionStatus(): string {
    console.log('about to execute getTransactionStatus in DashboardIdApplicationsPageRedirectHandler...');
    return null;
  }

  getOrderTransactionId(): string {
    console.log('about to execute getOrderTransactionId in DashboardIdApplicationsPageRedirectHandler...');
    return null;
  }

  getTransactionId(): string {
    console.log('about to execute getTransactionId in DashboardIdApplicationsPageRedirectHandler...');
    const clonedUrl = new URL(window.location.href);
    const sendToDcpId = clonedUrl.searchParams?.get(ResponseAttributes.SendToDCPID);
    return sendToDcpId;
  }

  getPageForSuccessfulProcess(): number {
    return 1;
  }

  getPageForUnsuccessfulProcess(): number {
    return 0;
  }

  getErrorMessageForUnsuccessfulProcess(language: string): string {
    return null;
  }

  populateApiRequest(programContainer: ProgramContainer): void {
  }
}